import { Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-headerLogin',
  templateUrl: './headerLogin.component.html'
})
export class HeaderLoginComponent implements OnInit {

  public logo: string;
  public site: string;
  constructor() {
}

ngOnInit() {
  this.logo = environment.logo;
  this.site = environment.site;
}
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/shared/headerLogin.component.ts